<div class="container flex" *ngIf="vm">
  <div class="left flex column">
    <div class="header">
      <h1
        contenteditable="true"
        #nameInput
        (input)="onNameInput($event)"
        (blur)="onNameBlur($event)"
        (focus)="onNameFocus($event)"
      ></h1>
      <p>
        <evrideo-hover-button
          [width]="'100px'"
          [backgroundColor]="'#DDE3E7'"
          (click)="vm.applyClicked()"
        >
          <span>APPLY</span>
        </evrideo-hover-button>
      </p>
    </div>
    <div class="body">
      <evrideo-layout-visual-editor [vm]="vm"></evrideo-layout-visual-editor>
    </div>
  </div>
  <div class="right flex column">
    <div class="right-side-panel" [ngStyle]="{ height: vm.windowHeightPx }">
      <span class="right-panel-header">Zone Settings</span>
      <evrideo-zone-editor
        *ngFor="let zone of vm.zones"
        [vm]="zone"
        [layoutViewModel]="vm"
      ></evrideo-zone-editor>
      <p>
        <button (click)="vm.addNewZoneClicked()">+Add New Zone</button>
      </p>
    </div>
  </div>

  <ngx-smart-modal
    #chooseSegment
    identifier="chooseSegmentModal"
    [@.disabled]="true"
    [customClass]="'nsm-centered'"
  >
    <evrideo-choose-segment></evrideo-choose-segment>
  </ngx-smart-modal>
</div>
